module.exports = __webpack_public_path__ + "static/media/Sales.c3f0c700.svg";